module.exports = __webpack_public_path__ + "static/media/customize.8087cedc.png";